/*
 *
 * OperationLoyaltyBonusList
 *
 * @version 1.0.0
 * @author Davide Polci
 * @since 15-Dec-2025
 */

import React from 'react'
import { defineMessages } from 'react-intl'
import PortalMessage from 'Hoc/PortalMessage'

const formattedMessage = {
  offerCode: <PortalMessage id='t.app.orders.operation.loyalty.bonusTable.offerCode' defaultMessage='Offer Code' />,
  offerName: <PortalMessage id='t.app.orders.operation.loyalty.bonusTable.offerName' defaultMessage='Offer Name' />,
  redeemedPoints: (
    <PortalMessage id='t.app.orders.operation.loyalty.bonusTable.redeemedPoints' defaultMessage='Redeemed Points' />
  ),
  redemptionAmount: (
    <PortalMessage id='t.app.orders.operation.loyalty.bonusTable.redemptionAmount' defaultMessage='Redemption Amount' />
  )
}

export const captions = defineMessages({
  points: {
    id: 't.app.orders.operation.loyalty.points',
    defaultMessage: 'points'
  },
  vouchersListTitle: {
    id: 't.app.orders.operation.loyalty.bonusTable.title',
    defaultMessage: 'List of vouchers used'
  }
})

export default formattedMessage

